// ----------------------------------------------------------------------------
// Snippet: Card
// ----------------------------------------------------------------------------
//
// ----------------------------------------------------------------------------


// -------------------------------------
// Dependencies
// -------------------------------------

// Scripts
import 'snippets/_containers/css-grid/css-grid';
import 'snippets/background-media/background-media';
import 'snippets/card-label/card-label';

// Styles
import './_card.scss';

import { changeSwatch, listenForImageEvents } from '../../assets/scripts/helpers/utilities';

const CARD_PRODUCT        = '.card--product';
const CARD_COLOR_OPTION   = '.card__swatch--color-option';

document.querySelectorAll(CARD_COLOR_OPTION)
    .forEach((element) => {

        element.addEventListener('click', (element) => {
            element.stopPropagation();
            const selectedSwatchOption = element.currentTarget;
            changeSwatch(selectedSwatchOption);
        });

        element.addEventListener('keydown', (element) => {
            element.stopPropagation();

            if (element.key === 'Enter') {
                const selectedSwatchOption = element.currentTarget;
                changeSwatch(selectedSwatchOption);
            }
        });
    });

document.querySelectorAll((CARD_PRODUCT))
    .forEach((element) => {

        listenForImageEvents(element);
    });
